import { render, staticRenderFns } from "./PhoneIndex.vue?vue&type=template&id=ef1fa210&scoped=true&"
import script from "./PhoneIndex.vue?vue&type=script&lang=js&"
export * from "./PhoneIndex.vue?vue&type=script&lang=js&"
import style0 from "./PhoneIndex.vue?vue&type=style&index=0&id=ef1fa210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1fa210",
  null
  
)

export default component.exports